/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_Doc_Packing_SlipInputs */

const vi_print_admin_doc_packing_slip = /** @type {(inputs: Print_Admin_Doc_Packing_SlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu đóng gói`)
};

/**

* @param {Print_Admin_Doc_Packing_SlipInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_doc_packing_slip = /** @type {((inputs?: Print_Admin_Doc_Packing_SlipInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_Doc_Packing_SlipInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_doc_packing_slip(inputs)
});